import { Translate } from 'react-redux-i18n'
import { Element } from '../common/html/element'
import classes from './Title.module.scss'

export const Title = ({ text }) => {
  return (
    <Element
      className={classes.userProfileTitle}
      style={{ color: '#0553A5', fontSize: 24 }}
    >
      <Translate value={text} />
    </Element>
  )
}
